"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../../deprecated/atoms/Icon");
var _globalTokens = require("../../shared/global-tokens");
var _jsxRuntime = require("react/jsx-runtime");
var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "NavBarIconButton__StyledButton",
  componentId: "sc-kmn3sq-0"
})(["width:48px;height:52px;padding:0 0 ", " 0;background:transparent;border-style:solid;border-color:transparent;border-width:", " ", " ", " 0 ", ";border-radius:", " ", " 0 0;cursor:pointer;position:relative;&:hover{background:", ";}&:focus-visible{outline:none;border-color:", ";}"], _globalTokens.globalSpacing['100'], _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.radius['2'], _globalTokens.globalBorder.radius['2'], function (props) {
  return props.theme.sys.color.background.primary['1'];
}, function (props) {
  return props.theme.sys.color.border.focusring;
});
var FloatingNumberBadge = _styledComponents.default.div.withConfig({
  displayName: "NavBarIconButton__FloatingNumberBadge",
  componentId: "sc-kmn3sq-1"
})(["position:absolute;display:flex;flex-direction:row;justify-content:center;align-items:center;bottom:calc(50% + ", ");left:calc(50% + ", ");width:auto;min-width:6px;height:16px;border-radius:24px;padding:2px 5px;background:", ";color:", ";font-size:10px;font-weight:500;font-family:'Inter';z-index:1;"], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['200'], function (props) {
  return props.theme.sys.color.background.semantic.error['2'];
}, function (props) {
  return props.theme.sys.color.text.content.ondark;
});
var NavBarIconButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
    icon = _ref.icon,
    counter = _ref.counter,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, ["disabled", "icon", "counter", "onClick"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, _objectSpread({
    ref: ref,
    disabled: disabled,
    onClick: onClick
  }, props, {
    children: [counter && /*#__PURE__*/(0, _jsxRuntime.jsx)(FloatingNumberBadge, {
      children: counter
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: icon,
      size: "m"
    })]
  }));
});
NavBarIconButton.defaultProps = {
  onClick: function onClick() {
    return void 0;
  },
  disabled: false
};
NavBarIconButton.propTypes = {
  onClick: _propTypes.default.func,
  counter: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.string.isRequired
};
var _default = exports.default = NavBarIconButton;